import { UserStorageRepository } from 'application/repositories/UserStorageRepository';
import { UserToken } from 'domain/entities/UserEntity';

const USER_LOCAL_STORAGE = 'user';
export class UserStorage implements UserStorageRepository {
    getUserInfo(): UserToken | null {
        if (!localStorage.getItem(USER_LOCAL_STORAGE)) return null;
        return JSON.parse(localStorage.getItem(USER_LOCAL_STORAGE) || '{}');
    }
    setUserInfo(user: UserToken): void {
        localStorage.setItem(USER_LOCAL_STORAGE, JSON.stringify(user));
    }
    removeUserInfo(): void {
        localStorage.removeItem(USER_LOCAL_STORAGE);
    }
    getUserRoles(): string[] {
        if (!localStorage.getItem(USER_LOCAL_STORAGE)) return [];
        const userLocal = JSON.parse(localStorage.getItem(USER_LOCAL_STORAGE) || '{}');
        return userLocal?.user?.roles ?? [];
    }
    getAccessToken(): string {
        const user = JSON.parse(localStorage.getItem(USER_LOCAL_STORAGE) || '{}');
        return user?.token;
    }
    getRefreshToken(): string {
        const user = JSON.parse(localStorage.getItem(USER_LOCAL_STORAGE) || '{}');
        return user?.refreshToken;
    }
    updateAccessToken(token: string): void {
        const user = JSON.parse(localStorage.getItem(USER_LOCAL_STORAGE) || '{}');
        localStorage.setItem(USER_LOCAL_STORAGE, JSON.stringify({
            ...user,
            token,
        }));
    }
}
